import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Styles from "../editScreenStyles.module.css";
import { yesNo, yesNoUnsure } from "../../../../constants/options";
import { copyNestedObjArray, textToBoolean } from "../../../../utilities/dataUtilities";
import inputUtilities from "../../../../utilities/forms/formInputUtilities";
import { states } from "../../../../constants/data";

function PassengersEdit({
  passengers,
  setPassengers,
  setIsVisible,
  isVisible,
  fields,
  utilities,
  validatePage,
  cancel
}) {
  const [originalPassengers, setOriginalPassengers] = useState([]);
  let passengerObj = useSelector((state) => state.anonAutoForm.passengerObj);
  const maxPassengers = 4;

  const {
    createToggleInput
  } = utilities;

  const addPassenger = () => {
    const newPassenger = {...passengerObj};
    for (let fieldName in newPassenger) {
      newPassenger[fieldName] = {
        ...newPassenger[fieldName],
        fieldName: `${newPassenger[fieldName].fieldName}${passengers.length}`
      };
    }
    setPassengers([...passengers, newPassenger]);
  };

  const removePassenger = (index) => {
    const newPassengers = [...passengers];
    newPassengers.splice(index, 1);
    setPassengers(newPassengers);
  };

  const createPassenger = (passenger, index) => {
    const setPassenger = (pass) => {
      const newPassengerInfo = [...passengers];
      newPassengerInfo[index] = pass;
      setPassengers(newPassengerInfo);
    };
    const createPassUtilities = inputUtilities(
      passenger,
      setPassenger,
      Styles
    )
    const createPassInput = createPassUtilities.createEditScreenInput;
    const createPassSelect = createPassUtilities.createCustomLabelSelect;
    const createPassToggle = createPassUtilities.createToggleInput;
    return (
      <li key={passenger.firstName.fieldName}>
        <div className={Styles.row}>
          <div className={Styles.half}>
            {createPassInput(passenger.firstName, "100%", Styles.input, `${Styles.label} ${Styles.wide}`)}
          </div>
          <div className={Styles.half}>
            {createPassInput(passenger.lastName, "100%", Styles.input, `${Styles.label} ${Styles.wide}`)}
          </div>
        </div>
        <div className={Styles.row}>
          <div className={Styles.half}>
            {createPassInput(passenger.address, "100%", Styles.input, `${Styles.label} ${Styles.wide}`)}
          </div>
          <div className={Styles.half}>
            {createPassInput(passenger.city, "100%", Styles.input, `${Styles.label} ${Styles.wide}`)}
          </div>
        </div>
        <div className={Styles.row}>
          <div className={Styles.half}>
            {createPassSelect(passenger.state, states, Styles.select, `${Styles.label} ${Styles.wide}`, { placeholder: "Select a State" })}
          </div>
          <div className={Styles.half}>
            {createPassInput(passenger.zipCode, "100%", Styles.input, `${Styles.label} ${Styles.wide}`)}
          </div>
        </div>
        <div className={Styles.row}>
          <div className={Styles.half}>
            {createPassInput(passenger.phoneNumber, "100%", Styles.input, `${Styles.label} ${Styles.wide}`, { type: "tel" })}
          </div>
        </div>
        <div className={Styles.row}>
          <div className={Styles.half}>
            {createPassToggle(passenger.isInjured, "100%", yesNo, true)}
          </div>
        </div>
        <div className={Styles.row}>
          <button
            type="button"
            className={Styles.button}
            onClick={() => removePassenger(index)}
          >
            Remove Passenger {index + 1}
          </button>
        </div>
      </li>
    );
  };

  const updateClicked = () => {
    if (validatePage(8, true)) {
      setIsVisible(false);
    }
  };

  const cancelClicked = () => {
    setPassengers([...originalPassengers]);
    cancel();
  };

  useEffect(() => {
    setOriginalPassengers(copyNestedObjArray(passengers));
  }, [isVisible]);

  useEffect(() => {
    if (!textToBoolean(fields.werePassengers.value)) {
      setPassengers([]);
    } else if (passengers?.length < 1) {
      addPassenger();
    }
  }, [fields.werePassengers.value])

  return (
    <div className={Styles.modalContainer}>
      <div className={Styles.title}>Passengers- Insured Vehicle</div>
      {createToggleInput(fields.werePassengers, "100%", yesNoUnsure, true)}
      <div className={Styles.column}>
        {textToBoolean(fields.werePassengers.value) && 
        <>
        <ol>
          {passengers?.map((passenger, index) => createPassenger(passenger, index))}
          </ol>
          </>
          }
          
            {textToBoolean(fields.werePassengers.value) && passengers?.length < maxPassengers && (
              <div className={Styles.addButtonWrapper}>
                <button
                  type="button"
                  className={Styles.addPassButton}
                  onClick={addPassenger}
                >
                  Add Passenger
                </button>
              </div>
            )}
            <hr></hr>
        <div className={Styles.buttons}>
           
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default PassengersEdit;
